import { render } from "./AddTypePieceModal.vue?vue&type=template&id=d0dceeda&ts=true"
import script from "./AddTypePieceModal.vue?vue&type=script&lang=ts"
export * from "./AddTypePieceModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__